export default "__VITE_ASSET__Csw0lJHR__"